
export const modifiedPreset = (state) => {
  const availColor= ['#EC255A', '#161853', '#3E8E7E', '#DE834D']
  const person = state.person.map((item, index) => ({
    userId: item.userId,
    name: item.digits, 
    freq: 3,
    bg: availColor[index],
    text: '#fff' ,
    hide: false,
    fontMod: 2
  }))
  return person
}

export const getGrandprizeName = (state) => {
  return state.grandprizes[0].prizes?.map(item => ({name: item.name, nominal: item.nominal}))
}

export const getGrandprizes = (state) => {
  return state.grandprizes
}

export const getAvailPersonGp = (state) => {
  console.log(state.person, "get person")
  const data = state.person.map(item => ({
    userId: item.userId,
    digits: item.digits
  }))
  return data
}